import { createGlobalStyle } from 'styled-components';
import { resetCss } from './resetCss';
import { BREAKPOINTS, FONT_SIZE, FONT_WEIGHT, media } from './themes/constants';
import {
  lightThemeVariables,
  darkThemeVariables,
  antOverrideCssVariables,
} from './themes/themeVariables';

export default createGlobalStyle`
  ${resetCss}

  [data-theme='light'],
  :root {
    ${lightThemeVariables}
  }

  [data-theme='dark'] {
    ${darkThemeVariables}
  }

  :root {
    ${antOverrideCssVariables}
  }

  html,
  body,
  #root,
  .App,
  .ant-app {
    min-height: 100%;
  }

  body,
  .App,
  .ant-app {
    background: var(--surface-page-color);
    color: var(--text-primary-color);
  }

  [data-no-transition] * {
    transition: none !important;
  }
  
  .range-picker {
    & .ant-picker-panels {
      @media only screen and ${media.xs} and (max-width: ${BREAKPOINTS.md - 0.02}px) {
        display: flex;
        flex-direction: column;
      }
    }
  }

  .search-dropdown {
    box-shadow: var(--box-shadow);

    @media only screen and ${media.xs} and (max-width: ${BREAKPOINTS.md - 0.02}px)  {
      width: calc(100vw - 16px);
      max-width: 600px;
    }

    @media only screen and ${media.md} {
      max-width: 323px;
    }
  }

  a {
    color: var(--primary-color);
    &:hover,
    &:active {
      color: var(--brand-primary-hover-color);
    }
  }
  
  .d-none {
    display: none;
  }

  .ant-picker-cell {
    color: var(--text-main-color);
  }

  .ant-picker-cell-in-view .ant-picker-calendar-date-value {
    color: var(--text-main-color);
    font-weight: ${FONT_WEIGHT.bold};
  }

  .ant-picker svg {
    color: var(--text-light-color);
  }
  .description {
    color: var(--text-primary-color);
    font-size: ${FONT_SIZE.md};
    font-weight: ${FONT_WEIGHT.semibold};
    line-height: 1.375rem;
  }

  .success-icon {
    color: var(--status-success-text-color);
  }

  .info-icon {
    color: var(--status-info-text-color);
  }

  .warning-icon {
    color: var(--status-warning-text-color);
  }

  .error-icon {
    color: var(--status-error-text-color);
  }

  .ant-menu-inline,
  .ant-menu-vertical {
    border-right: 0;
  }
`;
